export default __webpack_public_path__ + "static/media/twitter.ce5ee742.svg";